import apiAddress from "./apiAddress";
const image = `${apiAddress}/public/uploads/images`;
export default image;
